import { Flex, Modal, Card, Loader } from "rimble-ui"
import "@lottiefiles/lottie-player";
export default function Loading(props) {
  const {loading} = props

  return (
    <>
      <Modal isOpen={loading}>
        <Card style={{ width: '100%', maxWidth: '320px', borderRadius: 10, backgroundColor: 'white', border: '0px' }} p={0}>
          <Flex justifyContent='center' alignItems='center' height={220} flexDirection={'column'}>
            <Loader color="black" size="40px"/>
            <lottie-player src="https://assets8.lottiefiles.com/packages/lf20_o1gckjsf.json"  background="transparent"  speed="1"  style={{width: '100px', height: '300px'}}  loop autoplay></lottie-player>
          </Flex>
        </Card>
      </Modal>
    </>
  )
}